import { createFileRoute, Link } from '@tanstack/react-router';

function ProductDetail() {
  const { productId } = Route.useParams();
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ marginBottom: '10px', color: '#333' }}>
        Non-Nested Route: Product {productId} Detail
      </h1>
      <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
        파일은 <code>products_.$productId.detail.tsx</code> (underscore가
        products 뒤에)로 products 폴더 <strong>밖에</strong> 있어서 레이아웃을
        벗어났습니다.
      </p>
      <p
        style={{
          padding: '15px',
          background: '#fff3cd',
          border: '1px solid #ffc107',
          borderRadius: '4px',
          marginBottom: '20px',
        }}
      >
        ⚠️ 이 페이지는 products/route.tsx 레이아웃 없이 렌더링됩니다. 위의{' '}
        <strong>초록색 레이아웃이 보이지 않는 것</strong>을 확인하세요!
      </p>
      <nav>
        <Link to="/" style={{ marginRight: '10px', color: '#0066cc' }}>
          ← 홈으로
        </Link>
        <span style={{ margin: '0 5px', color: '#999' }}>|</span>
        <Link to="/products/123" style={{ color: '#0066cc' }}>
          일반 Nested Route 보기 (레이아웃 포함)
        </Link>
      </nav>
    </div>
  );
}

export const Route = createFileRoute('/sample/products_/$productId/detail')({
  component: ProductDetail,
});
